@file:OptIn(ExperimentalUuidApi::class)

package todo.pages

import androidx.compose.runtime.*
import app.AppProperties
import com.myrestaurants.sharedmodels.PlaceFilter
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.VerticalAlign
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
//import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLScriptElement
import kotlin.uuid.ExperimentalUuidApi

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import kotlinx.coroutines.CoroutineScope
import org.w3c.dom.HTMLInputElement
import org.w3c.fetch.RequestInit
import kotlin.js.json

import kotlinx.serialization.json.Json
import kotlinx.serialization.encodeToString

import kotlinx.serialization.json.jsonObject
import myrestaurants.MyRestaurantsProperties
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import kotlin.math.floor
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw
import org.w3c.dom.HTMLLinkElement
import org.w3c.dom.HTMLTextAreaElement
import org.w3c.dom.Element
import todo.Tagify
import com.myrestaurants.sharedmodels.Requirement
import com.myrestaurants.sharedmodels.Wish
import com.varabyte.kobweb.compose.css.FontWeight


var deviceId: String = ""
//var apiEndpoint = "https://www.myrestaurants.pt:442"
//var myRestaurantsProperties : MyRestaurantsProperties = MyRestaurantsProperties()
var minRatingFilter = 0f
var maxPriceFilter = 5f

//object AppBreakpoints {
//    val MOBILE = Breakpoint.SM
//    val TABLET = Breakpoint.MD
//    val DESKTOP = Breakpoint.LG
//}
//
////TODO - generate a token ni each login to validate all post requests
//
//val MainContainer = CssStyle.base {
//    Modifier
//        //.maxWidth(1500.px)
//        //.margin(leftRight = autoLength)
//        .padding(0.px).width(100.percent)
//}
//
//val CardStyle = CssStyle.base {
//    Modifier
//        .backgroundColor(rgb(255, 255, 255))
//        .padding(24.px)
//        .borderRadius(8.px)
//        .boxShadow(offsetX = 0.px, offsetY = 2.px, blurRadius = 4.px, color = rgba(0,0,0,0.1))
//}
//
//val InputStyle = CssStyle.base {
//    Modifier
//        .width(100.percent)
//        .maxWidth(400.px)
//        .padding(12.px)
//        .margin(bottom = 16.px)
//        .fontSize(10.px)
//        .borderRadius(4.px)
//        .border(1.px, LineStyle.Solid, rgb(200, 200, 200))
//}
//
//val ButtonStyle = CssStyle.base {
//    Modifier
//        .backgroundColor(rgb(100, 100, 100))
//        .color(Colors.White)
//        .padding(leftRight = 0.px, topBottom = 0.px)
//        .borderRadius(2.px)
//        .cursor(Cursor.Pointer)
//        .border(0.px)
//        .margin { 0.px }
//        .fontSize(10.px)
//        .styleModifier {
//            property("transition", "background-color 0.3s")
//        }
//        .styleModifier {
//            property(":hover", "{ background-color: rgb(29, 78, 216) }")
//        }
//}
//
//val ButtonModifier = CssStyle.base {
//    Modifier.margin(4.px).padding(0.px).fontSize(10.px).height(20.px)
//}
//
//val FormContainer = CssStyle.base {
//    Modifier
//        .padding(14.px)
//        .backgroundColor(rgb(255, 255, 255))
//        .borderRadius(8.px)
//        .boxShadow(offsetX = 0.px, offsetY = 2.px, blurRadius = 4.px, color = rgba(0,0,0,0.1))
//        .maxWidth(450.px)
//    //.maxHeight(500.px)
//}
//
//val TextSpanModifier = CssStyle.base {
//    Modifier
//        .fontSize(10.px)
//}
//
//val FormGroup = CssStyle.base {
//    Modifier
//        .margin(left = 2.px)
//        .fillMaxWidth()
////        .minWidth(400.px)
//        .maxWidth(650.px)
//    //.maxHeight(500.px)
//}
//
//val FormLabel = CssStyle.base {
//    Modifier
//        .fontSize(10.px)
//        .color(rgb(75, 85, 99))
//        .margin(bottom = 4.px)
//        .display(DisplayStyle.Block)
//}
//
//val FooterStyle = CssStyle.base {
//    Modifier
//        .zIndex(3)
//        .width(100.percent)
//        .backgroundColor(rgb(243, 244, 246))
//        .padding(8.px)
//        .margin(top = 8.px)
//        .verticalAlign(VerticalAlign.Bottom)
//        .textAlign(TextAlign.Center)
//}
//
//val SocialLinkStyle = CssStyle.base {
//    Modifier
//        .margin(left = 32.px)
//        .color(rgb(75, 85, 99))
////        .hover(
////            Modifier.color(rgb(59, 130, 246))
////        )
//}

//@Composable
//fun SiteFooter() {
//    Footer(
//        attrs = FooterStyle.toModifier().margin(top=0.px).padding(0.px).height(5.percent) /*.maxWidth(800.px)*/.toAttrs()
//    ) {
//        Row(
//            modifier = Modifier.margin(top=0.px).padding(0.px),
//            horizontalArrangement = Arrangement.SpaceBetween,
//            verticalAlignment = Alignment.Bottom
//        ) {
//            Row(
//                modifier = Modifier.gap(4.px)/*.maxWidth(800.px)*/,
//                verticalAlignment = Alignment.Bottom
//            ) {
//                Span(TextSpanModifier.toModifier().toAttrs()) {
//                    Text("© 2025 My Restaurants. All rights reserved.    ")
//                }
//            }
//            Row(
//                modifier = Modifier.gap(4.px)/*.maxWidth(800.px)*/,
//                verticalAlignment = Alignment.Bottom
//            ) {
//                Link(
//                    "https://instagram.com/myrestaurants.pt",
//                    SocialLinkStyle.toModifier()
//                ) {
//                    Image(
//                        src = "/social/instagram.svg",
//                        alt = "Instagram",
//                        modifier = Modifier.width(20.px).height(20.px)
//                    )
//                }
//
//                Link(
//                    "https://facebook.com/myrestaurants.pt",
//                    SocialLinkStyle.toModifier()
//                ) {
//                    Image(
//                        src = "/social/facebook.svg",
//                        alt = "Facebook",
//                        modifier = Modifier.width(20.px).height(20.px)
//                    )
//                }
//
//                Link(
//                    "mailto:main@myrestaurants.pt",
//                    SocialLinkStyle.toModifier()
//                ) {
//                    Image(
//                        src = "/social/email.svg",
//                        alt = "Email",
//                        modifier = Modifier.width(20.px).height(20.px)
//                    )
//                }
//            }
//        }
//    }
//}

@Composable
fun WishSelector(
    selected: Wish?,
    onSelection: (Wish?) -> Unit,
) {


    Row(
        modifier = Modifier
            .gap(2.px)
            .display(DisplayStyle.Flex)
//            .responsive {
//                // stack vertically on narrow screens
//                Modifier.displayStyle(DisplayStyle.Block)
//            }
    ) {
        Wish.values().forEach { option ->
            val isSelected = option == selected
            if(option != Wish.NotSpecified)(
                    com.varabyte.kobweb.silk.components.forms.Button(
                        onClick = {
                            onSelection(if (isSelected) null else option)
                        },
                        modifier = ButtonModifier.toModifier()
                            .fontSize(0.8.em)
                            //.width(1.2.em)
                            .color(if (isSelected) Color.black else Color.gray)
                    ) {
                        Text(option.label)
                    }
                    )
        }
    }
}

@Composable
fun RequirementSelector(
    selected: Requirement?,
    onSelection: (Requirement?) -> Unit,
) {


    Row(
        modifier = Modifier
            .gap(2.px)
            .display(DisplayStyle.Flex)
//            .responsive {
//                // stack vertically on narrow screens
//                Modifier.displayStyle(DisplayStyle.Block)
//            }
    ) {
        Requirement.values().forEach { option ->
            val isSelected = option == selected
            if(option != Requirement.NotSpecified)(
                    com.varabyte.kobweb.silk.components.forms.Button(
                        onClick = {
                            onSelection(if (isSelected) null else option)
                        },
                        modifier = ButtonModifier.toModifier()
                            .fontSize(0.6.em)
                            //.width(1.2.em)
                            .color(if (isSelected) Color.black else Color.gray)
                    ) {
                        Text(option.label)
                    }
                    )
        }
    }
}



@Composable
fun RestaurantTagsSelector(id : String = "restaurant-tags-selector", maxTags: Int = 10) {
    // Keep the current tags in Compose state if you like
    var selectedTags by remember { mutableStateOf<List<String>>(emptyList()) }

    Box(Modifier.width(350.px)) {
        // Render the input
        Input(
            type = InputType.Text,
            attrs = Modifier
                .padding(2.px)
                .toAttrs {
                    attr("placeholder", "Pick Category…")
                    attr("id", id)
//                    attr("value", selectedTags.toString()) // `tags` is your state variable
//                    onInput { event -> selectedTags = event.value }
                }
        )
    }

    LaunchedEffect(Unit) {
        val input = document.getElementById(id)
                as? HTMLInputElement ?: return@LaunchedEffect

        val settings = json(
            "delimiters" to ", ",
            "enforceWhitelist" to true,
            "maxTags" to maxTags,
            "dropdown" to json(
                "classname"     to "tagify__dropdown--custom",
                "enabled"       to 0,          // show suggestions on focus :contentReference[oaicite:2]{index=2}
                "maxItems"      to 10,
                "position"      to "text",
                "closeOnSelect" to false,
                "highlightFirst" to true
            ),
            "whitelist"  to arrayOf(
                "Private Room","Pet Friendly","African","Arabian","Argentinian","Asian","Brazilian","Brunch","Buffets","Burgers","Chinese","Comfort Food","Dim Sum","Family","Fast Food","Fine Dining","Healthy","Indian","Italian","Kids friendly","Mexican","Middle Eastern","Noodles","Nouvelle cuisine","Open-air","Organic","Party","Pasta","Persian/Iranian","Open Late","Peruvian","Pizza","Portuguese","Quiet","Ramen","Ribs","Salad","Sandwiches","Seafood","Snack","Soup","Steakhouse","Sushi","Vegan","Vegetarian"
            )
        )

        delay(2000)

        val tagify = Tagify(input, settings)
        window.asDynamic().setTagsFromJS = { tags: String ->
            val tagList = tags.split(";").map { it.trim() }.filter { it.isNotEmpty() }
            console.log("tags from JS: $tagList")
            selectedTags = tagList
            // Update Tagify UI
            tagify.removeAllTags()
            tagify.addTags(tagList.toTypedArray())
        }


        input.addEventListener("focus", {
            js("tagify.dropdown.show()")
        })

        // 5) Sync back to Compose state whenever tags change
        input.addEventListener("change", {
            console.log("changed tag input")
            @Suppress("UNCHECKED_CAST")
            val arr = js("tagify.value") as Array<dynamic>
            selectedTags = arr.map { it.value as String }
        })
    }

    // For demo: show the current selection
//    if (selectedTags.isNotEmpty()) {
    TagList(selectedTags)
//    }
}

var selectedTags = ""
var needReservationFilter : Int? = 0
var wishFilter : Int? = 0
var needReservation : Int? = 0


@Composable
private fun TagList(tags: List<String>) {
    Column {
        //Text("You’ve selected:")
        selectedTags = ""
        tags.forEach {
            selectedTags += ";" + it
            //SpanText("•$it", Modifier.margin(bottom = 4.px))
        }
        selectedTags = selectedTags.substring(1)
    }
}

fun loadTagifyCSS(onLoaded: () -> Unit = {}) {
    console.log("loadTagifyCSS")
    if (window.asDynamic().google?.maps != undefined) {
        onLoaded()
        return
    }
    val link = window.document.createElement("link") as HTMLLinkElement
    link.setAttribute("rel", "stylesheet")
    link.setAttribute("href", "https://cdn.jsdelivr.net/npm/@yaireo/tagify@4.35.1/dist/tagify.min.css")
    window.document.head?.appendChild(link)
}


//fun loadMyScripts(onLoaded: () -> Unit = {}) {
//    console.log("loadMyScripts")
//    if (window.asDynamic().google?.maps != undefined) {
//        onLoaded()
//        return
//    }
//    val script = window.document.createElement("script") as HTMLScriptElement
//    script.setAttribute("src", "/scripts/myScript.js")
//    script.setAttribute("type", "text/javascript")
//    script.onload = { onLoaded() }
//    window.document.head?.appendChild(script)
//}

fun loadYaireoScript(onLoaded: () -> Unit = {}) {

    val jqueryScript = window.document.createElement("script") as HTMLScriptElement
    jqueryScript.setAttribute("src", "https://cdn.jsdelivr.net/npm/@yaireo/tagify")
    jqueryScript.setAttribute("src", "scripts/yaireo.js")
    jqueryScript.setAttribute("type", "text/javascript")
    jqueryScript.onload = {
        onLoaded()
    }
    window.document.head?.appendChild(jqueryScript)
    console.log("Yaireo loaded")
}

fun loadTagSelectorScript(onLoaded: () -> Unit = {}) {
    console.log("loadTagSelectorScript")
    if (window.asDynamic().google?.maps != undefined) {
        onLoaded()
        return
    }
    val tagSelectorScript = window.document.createElement("script") as HTMLScriptElement
    tagSelectorScript.setAttribute("src", "/scripts/tag_selector.js")
    tagSelectorScript.setAttribute("type", "text/javascript")
    tagSelectorScript.onload = { onLoaded() }
    window.document.head?.appendChild(tagSelectorScript)
}

fun loadGoogleMapsScript(apiKey: String, onLoaded: () -> Unit) {
//    if (window.asDynamic().google?.maps != undefined) {
//        onLoaded()
//        return
//    }
    //TODO - spinning wheel waiting for google maps to load

    val script = window.document.createElement("script") as HTMLScriptElement
    script.src = "https://maps.googleapis.com/maps/api/js?key=$apiKey&libraries=places&callback=initMap&loading=async"
    script.async = true
    script.defer = true

    // Add error handling
    script.onerror = { b: dynamic, s: String, i: Int, i1: Int, any: Any? ->
        console.error("Failed to load Google Maps script")
        // Retry after delay
        window.setTimeout({
            loadGoogleMapsScript(apiKey, onLoaded)
        }, 2000)
    }

    window.document.head?.appendChild(script)
}


//fun generateId(): String = "map-" + Uuid.random().toString().substring(2)


fun loadGoogleAuthScript() {
    loadGoogleAuthScript(onLoaded = {
        console.log("google auth loaded")
    })
}

fun JsInteropPage(deviceId: String) {

    loadYaireoScript() {
        console.log("yaireo loaded")
    }
    loadTagifyCSS() {
        console.log("tagifycss loaded")
    }
    loadMyScripts(onLoaded =  {
        console.log("loading myscripts")
        js("setDeviceId")(deviceId)
        //TODO - change listId to dynamic
        js("setPlacesFilter")("{\"deviceId\":\"$deviceId\",\"listId\":\"Main List\"}")
        loadGoogleMapsScript("AIzaSyD267XUQtrBipo3T8aIisEGp9lEPDM2ilE", onLoaded = {
        })
    })
}

fun JsInteropPage2(deviceId: String) {

    loadYaireoScript() {
        console.log("yaireo loaded")
    }
    loadMyScripts(onLoaded =  {
        js("setDeviceId")(deviceId)
    })
    loadGoogleMapsScript("key", onLoaded = {
    })
}




@Page
@Composable
fun HomePageOriginal() {


    val context = rememberPageContext()
    // Get URL parameters
    val params = context.route.params

    // You can access specific parameters like this:
    val activateCode = params["activateCode"] // will return null if parameter doesn't exist
    val email = params["email"]
    val resetCode = params["resetCode"]

    console.log("activateCode: $activateCode")
    console.log("email: $email")

    loadGoogleAuthScript()

    // NEW: Provide the Google auth POST endpoint to the JS script
    LaunchedEffect(Unit) {
        // apiEndpoint is already used elsewhere in this file
        window.asDynamic().googleAuthPostUrl = apiEndpoint + "/api/google-auth"
    }

    if(!activateCode.isNullOrBlank() && !email.isNullOrBlank()) {
        activateAccount(activateCode, email, onActivateSuccess =
        {
            println("Account activated for email: $it")
            window.localStorage.setItem("username", email)
            window.localStorage.setItem("deviceId",email)
            context.router.navigateTo("/")
        }
        )
        return
    }


    var username by remember { mutableStateOf("") }
    var isLoggedIn by remember { mutableStateOf(false) }

    // Add state for showing/hiding left side content
    var showLeftSideContent by remember { mutableStateOf(false) }

    val storedUser = window.localStorage.getItem("username")
    isLoggedIn = !storedUser.isNullOrBlank()


    var isMobile by remember { mutableStateOf(false) }
    var showSideContent by remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
        window.asDynamic().showSideContent = { show: Boolean ->
            // Update the Compose state from JS
            showSideContent = show
        }
    }

    // Set up breakpoint detection
    LaunchedEffect(Unit) {
        isMobile = window.innerWidth <= 480
        console.log("isMobile: $isMobile - innerWidth: ${window.innerWidth}")
        window.onresize = {
            console.log("resized-it:" + it)
            //invoke js function to check if it is mobile
        }
    }

    Column(
        modifier = MainContainer.toModifier()
            .width(100.percent)
            .height(100.vh)  // Set height to 100% viewport height
            .overflow(Overflow.Hidden)  // Prevent scrolling
    ) {
        // Header Box
        Box(
            Modifier
                .fillMaxWidth()
                .backgroundColor(rgb(0, 0, 0))
                .color(rgb(256, 256, 256))
                .height(if(isMobile) 5.vh else 9.vh)
                .padding(0.px)
        ) {
            Row(
                modifier = Modifier.fillMaxWidth().height(12.percent).margin(/*top=if(isMobile)5.percent else */0.percent),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.Top
            ) {
                Link("/") {
                    Image(
                        src = logoMyRestaurants,
                        alt = "Logo",
                        modifier = Modifier.width(5.vh).height(5.vh)
                    )
                }
                if(isLoggedIn || !window.localStorage.getItem("username").isNullOrBlank()) {
                    UserOnHeader(
                        isLoggedIn = true,onLogout = {
                            isLoggedIn = false
                        }
                    )
                }
            }
        }

        // Main content area - This should take remaining space without scrolling
        Box(
            Modifier
                .fillMaxWidth()
                .height(if(isMobile) 80.vh else 91.vh)  // Adjust height based on header
                .overflow(Overflow.Hidden)  // Prevent main content scrolling
        ) {
            Row(
                Modifier
                    .fillMaxWidth()
                    .padding(top = 0.px, bottom = 0.px)
//                    .width(40.percent)
                    .gap(8.px)
//                    .maxWidth(100.percent)
                    .alignItems(AlignItems.Start)
            ) {
                // Collapse/Expand Button
                if (isLoggedIn) {
                    Column(
                        Modifier.margin(top = 15.vh).zIndex(3)
                    ) {
                    com.varabyte.kobweb.silk.components.forms.Button(
                        onClick = {
                            showLeftSideContent = !showLeftSideContent;
//                            showLeftSideContent = true;
                            console.log("showLeftSideContent: $showLeftSideContent")
                                  },
                        modifier = Modifier.fontSize(10.px).height(25.px).backgroundColor(Colors.White)
                            .borderRadius(5.px).border(1.px, LineStyle.Solid, rgb(100, 100, 100))
                        ) {
                            Text(if (showLeftSideContent) "⏴ Hide Filters" else "⏵ Show Filters")
                        }
                    }
                    Column(
//                        Modifier.zIndex(3)
                        Modifier.zIndex(if(showLeftSideContent) 3 else -1)
                    ) {

//                }
                        // Left Side Content (collapsible)
                        if (isLoggedIn /*&& showLeftSideContent*/) {
                            Column(
//                                Modifier
//                                    .zIndex()
                            ) {
                                console.log("showLeftSideContent: $showLeftSideContent")
                                LeftSideContent(
                                    onClickFilter = {
                                        showLeftSideContent = false;
                                        console.log("onClickFilter called")
                                    },
                                    showLeftSideContent
                                )
                            }
                        }
                    }
                }
                // Main Content
                Column(
                    Modifier
                        .backgroundColor(rgb(255, 255, 255))
                        .padding(0.px)
                        .position(Position.Absolute)
                        .width(100.percent)
                        .height(100.percent)
                        .borderRadius(8.px)
                        .boxShadow(offsetX = 0.px, offsetY = 2.px, blurRadius = 4.px, color = rgba(0,0,0,0.1))
                ) {

                    Row(
                        modifier = Modifier.fillMaxWidth().gap(8.px).width(100.percent)
                            .height(100.percent).alignItems(AlignItems.Start),
                        horizontalArrangement = Arrangement.Center

                    ) {
                        Column(
                            Modifier.fillMaxWidth().fontSize(18.px).margin(top = 40.px),
                            horizontalAlignment = Alignment.CenterHorizontally
                        ) {
                            // Login Form
                            if (!isLoggedIn) {
                                Div(
                                    Modifier
                                        .width(if (isMobile) 95.percent else 70.percent).margin(25.px)
                                        .textAlign(TextAlign.Center).fontWeight(FontWeight.Bold)
                                        .fontSize(20.px)
                                        .toAttrs()
                                ) {
                                    Text("Welcome to My Restaurants!")
                                }
                                Div(
                                    Modifier.margin(left = 40.px, right = 40.px)
                                        .textAlign(TextAlign.Center).toAttrs()
                                ) {
                                    Text("Track your favorite restaurants!")
                                    Spacer()
                                    Text("Organize your favorite dining spots, build lists, and enjoy every meal with My Restaurants. Remember great places and share your discoveries with friends and family")
                                    Text("My Restaurants is a simple way to manage your restaurant life. Find restaurants that match your taste and plans. Instead of forgetting names, locations, or what you thought about a place, you can keep everything in one clean and organized space. It makes tracking restaurants easier, helps you revisit your favorite dining spots, and gives you a better way to find restaurants when you need them most.")
                                }
                                Column {
                                    if (!resetCode.isNullOrBlank() && !email.isNullOrBlank()) {
                                        Box(CardStyle.toModifier()) {
                                            ResetPassForm(email = email, resetCode = resetCode,
                                                onSetNewPasswordSuccess = { email: String, resetCode: String, deviceId: String ->
                                                    console.log("Reset password success for email: $email, resetCode: $resetCode")
                                                    isLoggedIn = true
                                                    username = email
                                                    context.router.navigateTo("/")
                                                    window.localStorage.setItem("username", email)
                                                    window.localStorage.setItem(
                                                        "deviceId",
                                                        deviceId
                                                    )
                                                }
                                            )
                                        }
                                    } else {
                                        Div(
                                            Modifier.height(5.vh)
                                                //width(100.percent).height(86.vh).borderRadius(0.px)
                                                //.margin(top = 0.px)
                                                .attr("id", "g_id_onload")
                                                .attr("data-auto_prompt", "false")
                                                .attr("data-callback", "handleCredentialResponse")
                                                .attr(
                                                    "data-client_id",
                                                    "106656672549-jhg3ge7n5a1f54ahik3no2blq17ubj6d.apps.googleusercontent.com"
                                                )
                                                .textAlign(TextAlign.Center).toAttrs()
                                        )
                                        Div(
                                            Modifier
                                                //width(100.percent).height(86.vh).borderRadius(0.px)
                                                .attr("class", "g_id_signin").toAttrs()
                                        )
                                        LaunchedEffect(Unit) {
                                            if (!isLoggedIn) {
                                                console.log("not logged in")
                                                val reloaded =
                                                    window.sessionStorage.getItem("reloadedOnce")
                                                if (reloaded != "true") {
                                                    window.sessionStorage.setItem(
                                                        "reloadedOnce",
                                                        "true"
                                                    )
                                                    window.location.reload()
                                                } else {
                                                    window.sessionStorage.removeItem("reloadedOnce")
                                                }
                                            }
                                        }
                                        Box(CardStyle.toModifier()) {
                                            LoginForm(
                                                onLoginSuccess = { a: String, b: String, c: String ->
                                                    isLoggedIn = true
                                                    username = a
                                                    context.router.navigateTo("/")
                                                    window.localStorage.setItem("username", a)
                                                    window.localStorage.setItem("deviceId", b)
                                                    window.localStorage.setItem("userId", c)
                                                }
                                            )
                                            //                            Link(
                                            //                                path = "/forgot-password",
                                            //                                modifier = Modifier
                                            //                                    .color(rgb(51, 51, 51))
                                            //                                    .textDecorationLine(TextDecorationLine.Underline)
                                            //                            ) {
                                            //                                Text("Forgot your password?")
                                            //                            }
                                        }
                                        Box(CardStyle.toModifier()) {
                                            RegisterForm(
                                                onRegisterSuccess = {
                                                    //                                    isLoggedIn = true
                                                    //                                    username = it
                                                    //                                    context.router.navigateTo("/")
                                                    //                                    window.localStorage.setItem("username", it)
                                                    //                                    window.localStorage.setItem("deviceId", it)
                                                }
                                            )
                                        }
                                    }
                                }
                            }
                            Column {
                                if (isLoggedIn) {
                                    // Show SideContent button on mobile
//                                if (isMobile) {
//                                    com.varabyte.kobweb.silk.components.forms.Button(
//                                        onClick = { showSideContent = true },
//                                        modifier = Modifier.margin(bottom = 8.px)
//                                    ) {
//                                        Text("Show Details")
//                                    }
//                                }
                                    HomePage2(true, onLogout = { isLoggedIn = false })
                                }

                            }
                        }
                    }
                }

                // Side Content
                if (isLoggedIn) {
                    isMobile = true //don't show side content, as if it is always mobile
                    if (!isMobile) {
                        // Desktop: show as before
                        Column(
                            Modifier
                                .position(Position.Absolute)
                                .maxHeight( 400.px)
//                        .backgroundColor(rgb(256, 256, 256))
                                .padding(8.px)
                                .zIndex(2)
                                .margin(left=65.percent)
//                        .alignItems(AlignItems.Start)
                            //.borderRadius(8.px)
                            //.boxShadow(offsetX = 0.px, offsetY = 2.px, blurRadius = 4.px, color = rgba(0,0,0,0.05))
                        ) {
                            SideContent()
                        }
                    } else {
                        // Mobile: show as overlay/modal
                        Box(
                            Modifier
                                .position(Position.Fixed)
                                .top(0.px)
                                .left(0.px)
                                .width(10.vw)
                                .height(50.vh)
                                .margin(top = 0.px, left = 5.vh, right = 0.px)
                                .backgroundColor(rgba(0, 0, 0, 0.5))
                                .zIndex(if (showSideContent) 101 else -1) // Show only when `showSideContent` is true
                                .onClick { /*showSideContent = false*/ }
                        ) {
                            Column(
                                Modifier
                                    .backgroundColor(Colors.White)
                                    .padding(2.px)
                                    .margin(top = 0.px, left = 1.vh, right = 0.px)
                                    .borderRadius(0.px)
                                    .width(10.vw)
                                    .maxHeight(40.vh)
                                    .position(Position.Absolute)
                                    .zIndex(if (showSideContent) 101 else -1)
                                    .onClick { /* prevent modal close on content click */ },
                                horizontalAlignment = Alignment.Start
                            ) {
                                SideContent(onCloseWindow = { showSideContent = false})
                            }
                        }
                    }
                }
            }
        }


    }
}

//fun activateAccount(activateCode: String, email: String, onActivateSuccess : (String) -> Unit) : String{
//
//    window.fetch(
//        apiEndpoint + "/api/activate-account",
//        RequestInit(
//            method = "POST",
//            headers = json("Content-Type" to "application/json","Accept" to "application/json"),
//            body = "{\"activateCode\":\"$activateCode\", \"email\":\"$email\",\"deviceId\":\"\", \"password\":\"\"}"
//        )
//    ).then { response ->
//        response.text().then { body ->
//            if (response.ok) {
//                onActivateSuccess(email)
//                "Please check your email for confirmation."
//
//            } else {
//                console.log("Error response body: $body")
//                body
//            }
//        }
//    }
//    return "Please check your email for confirmation."
//}


//@Composable
//fun UserOnHeader(isLoggedIn: Boolean, onLogout: () -> Unit) {
//    console.log("Header")
//    if(!isLoggedIn){
//        console.log("not logged in")
//        return
//    }
//    var isLoggedIn by remember { mutableStateOf(false) }
//    var username by remember { mutableStateOf("") }
//
//    val storedUser = window.localStorage.getItem("username")
//    if (!storedUser.isNullOrBlank()) {
//        username = storedUser
//        isLoggedIn = true
//    }
//    console.log("isLoggedIn:" + isLoggedIn)
//    if (isLoggedIn) {
//        Spacer()
//        val storedUser = window.localStorage.getItem("username")
//        if (!storedUser.isNullOrBlank()) {
//            username = storedUser
//
//            Span(TextSpanModifier.toModifier().toAttrs()){
//                Text("Welcome $username!  ")
//            }
//            com.varabyte.kobweb.silk.components.forms.Button(onClick = {
//                isLoggedIn = false
//                username = ""
//                window.localStorage.removeItem("username")
//                window.localStorage.removeItem("deviceId")
//                onLogout()},
//                modifier = ButtonStyle.toModifier().backgroundColor(Colors.LightGray)
//                    .color(Colors.Black).height(25.px)
//
////                ,
////                modifier = ButtonStyle.toModifier().margin(5.px).backgroundColor(Colors.LightGray)
////                    .color(Colors.Black)
//            )
//            {
//                Text("Logout")
//            }
//        }
//    }
//}

@Composable
fun HomePage2(isLoggedIn: Boolean, onLogout: () -> Unit) {
    console.log("Homepage")

    if(!isLoggedIn){
        console.log("not logged in")
        return
    }


    //val coroutineScope = rememberCoroutineScope()

    var isLoggedIn by remember { mutableStateOf(false) }
    var username by remember { mutableStateOf("") }
    var requirement by remember { mutableStateOf<Requirement?>(null) }
    var ready by remember { mutableStateOf(false) }

    val context = rememberPageContext()


    LaunchedEffect(Unit) {




        val storedUser = window.localStorage.getItem("username")
        val storedDeviceId = window.localStorage.getItem("deviceId")
        if (!storedUser.isNullOrBlank()) {
            username = storedUser
            deviceId = storedDeviceId ?: ""
            console.log("Stored username: $username, deviceId: $deviceId")
            isLoggedIn = true


            JsInteropPage(deviceId)

//            window.fetch("/api/config")
//                .then { response ->
//                    if (response.ok) response.text()
//                    else throw Error("Failed to load config")
//                }
//                .then { content ->
//                    appProperties = Json.decodeFromString<AppProperties>(content)
//                    apiEndpoint = appProperties.apiEndpoint
//                    console.log("Loaded Props: $appProperties")
//                    JsInteropPage(deviceId)
//                }
//                .catch { error ->
//                    console.error("Error loading config: $error")
//                    //apiEndpoint = "http://localhost:8080/"
//                }
        }

        ready = true

    }

    Column(
        modifier = MainContainer.toModifier().height(100.percent).margin(left=5.percent)/*.width(800.px)*/,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        if (!isLoggedIn) {
        } else {

//            Column(
//                modifier = MainContainer.toModifier().width(800.px).fillMaxSize(),
//                horizontalAlignment = Alignment.CenterHorizontally
//            ) {
//                Row(
//                    modifier = Modifier.fillMaxWidth().margin(bottom = 24.px),
//                    horizontalArrangement = Arrangement.Start,
//                    verticalAlignment = Alignment.CenterVertically
//                ) {
//                    Text(
//                        "Welcome $username!",
//                        //modifier = Modifier.fontSize(24.px).fontWeight(FontWeight.Bold)
//                    )
//
//
//                }
//            }
            Column(
                modifier = MainContainer.toModifier().position(Position.Absolute)
                    .height(100.percent).fillMaxSize()/*.minWidth(1200.px)*/,
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Top
            ) {

//                com.varabyte.kobweb.silk.components.forms.Button(onClick = {
//                    //val showAlert = js("window.showAlert") as? (String) -> Unit
//                    //showAlert?.invoke("Hello from Kotlin/JS!")
//
//                    val loadMarkers = js("loadMarkers") as? (String) -> Unit
//                    loadMarkers?.invoke(deviceId)
//
//                    val loadAutoComplete = js("loadAutoComplete") as? (String) -> Unit
//                    loadAutoComplete?.invoke(deviceId)
//
//                }) {
//                    Text("Load My Maps")
//                }

                //Link("https://github.com/varabyte/kobweb", "Kobweb!")


                Box(
                    modifier = Modifier
                        .position(Position.Absolute)
                        .fillMaxWidth()
                        .height(100.percent)
//                        .overflow(Overflow.Auto)  // Enable scrolling
                        .zIndex(1)
                        .margin(left = 0.px)
                ) {
                    var isLoadingLocation by remember { mutableStateOf(false) }
                    var isMobile by remember { mutableStateOf(false) }

                    LaunchedEffect(Unit) {
                        window.asDynamic().setLocationLoadingState = { loading: Boolean ->
                            isLoadingLocation = loading
                        }
                        isMobile = window.innerWidth <= 480
                    }

                    StyledTextInput(
                        "autocomplete", "Enter restaurant name or location",
                        modifier = Modifier
                            .position(Position.Relative)
                            .margin(left = if(isMobile) 19.percent else 18.percent)
                            .zIndex(3)
                            .fontSize(if(isMobile) 12.px else 20.px)
                            .width(if(isMobile) 75.vw else 65.vw)
                            //.left(600.px)
                            .top(30.px)
//                            .fontWeight(FontWeight.Bold)  // Added this line
                            .color(Colors.Black)         // Added this line
                        ,
                        3,
                        65.px,
                        24.px
                    )

                    Span(
                        Modifier.textAlign(TextAlign.Center)
                            .zIndex(4)
                            .backgroundColor(Colors.White)
                            .padding(10.px)
                            .textAlign(TextAlign.Center)
                            .margin(top = 30.vh, left = 45.vw).verticalAlign(VerticalAlign.Middle)
                            .attr("id", "loading_restaurants_msg")
                            .toAttrs()
                    ) {
                        Text("Loading Restaurants... Please wait")
                    }

                    //TODO - Actually, I only need to get the current location in the beginning

                    // Location button with loading state
                    com.varabyte.kobweb.silk.components.forms.Button(
                        onClick = {
                            js("getMyLocation")()
                        },
                        modifier = Modifier
                            .position(Position.Absolute)
                            .margin(left = 21.percent)
                            .zIndex(3)
                            .top(55.px)
                            .padding(2.px)
                            .backgroundColor(Colors.White)
                            .cursor(if (isLoadingLocation) Cursor.Wait else Cursor.Pointer)
                            .borderRadius(4.px)
                            .border(1.px, LineStyle.Solid, rgb(200, 200, 200))
                    ) {
                        Box(Modifier.display(DisplayStyle.Flex).gap(8.px)) {
                            Image(
                                src = "/icons/my-location.svg",
                                alt = "My Location",
                                modifier = Modifier
                                    .size(if(isMobile) 12.px else 24.px)
                                    .styleModifier {
                                        if (isLoadingLocation) {
                                            property("animation", "spin 2s linear infinite")
                                        }
                                    }
                            )
                            if (isLoadingLocation) {
                                Text("Getting location...")
                            }
                        }
                    }
                    Column (modifier = Modifier
                        .position(Position.Absolute)
                        .fillMaxWidth()
                        .height(86.vh)
//                        .overflow(Overflow.Auto)  // Enable scrolling
                        .zIndex(1)
                        .margin(left = 0.px, top = 0.px)) {
                        Div(
                            Modifier.width(100.percent).height(86.vh).borderRadius(0.px)
                                .margin(top = 0.px)
                                .attr("id", "map-container").textAlign(TextAlign.Center).toAttrs()
                        )
                        {
                            Span(
                                Modifier.textAlign(TextAlign.Center)
                                    .margin(top = 100.px).verticalAlign(VerticalAlign.Middle)
                                    .toAttrs()
                            ) {
                                Text("Loading Map...Please wait")
                            }
                        }
                        // Footer
                        SiteFooter()
                    }
                }
            }
        }
    }
}

@Composable
fun LeftSideContent(onClickFilter: () -> Unit, showLeftSideContent: Boolean = true) {

    var isLoggedIn by remember { mutableStateOf(false) }

    val coroutineScope = rememberCoroutineScope()

    var requirement by remember { mutableStateOf<Requirement?>(null) }
    var wish by remember { mutableStateOf<Wish?>(null) }
    var ratingFilter : Float = 0f
    var priceFilter : Float = 50f
//    var ratingFilter by remember { mutableStateOf(0) }

    LaunchedEffect(Unit) {
        window.asDynamic().setRequirementSelection = { ordinal: Int ->
            // Update the Compose state from JS
            requirement = Requirement.values().getOrNull(ordinal)
        }
    }

//    Column(
//        modifier = Modifier.margin(left = 2.cssRem).alignItems(AlignItems.Start)/*.maxHeight(400.px)*/,
//        horizontalAlignment = Alignment.Start,
//        verticalArrangement = Arrangement.Top
//    ) {

    Column(
        modifier = FormContainer.toModifier().width(100.percent),
        horizontalAlignment = Alignment.Start
    ) {

        var resetButtonEnabled by remember { mutableStateOf(false) }

        fun resetAllFilters() {
            // Reset range sliders
            ratingFilter = 0f
            minRatingFilter = 0f
            maxPriceFilter = 5f

            // Reset range input elements
            val ratingInput = document.getElementById("rating-filter") as? HTMLInputElement
            ratingInput?.value = "0"

            val priceInput = document.getElementById("price-filter") as? HTMLInputElement
            priceInput?.value = "0"

            // Update range filter displays
            val minRatingSpan = document.getElementById("minRating") as? Element
            minRatingSpan?.textContent = "0"

            val maxPriceSpan = document.getElementById("maxPrice") as? Element
            maxPriceSpan?.textContent = "5"

            js("setRangeFilter")("minRating", 0f)
            js("setRangeFilter")("maxPrice", 5f)

            // Reset text input
            val placeNameFilter = document.getElementById("place_name_filter") as? HTMLInputElement
            placeNameFilter?.value = ""

            // Reset wish and requirement selections
            wish = null
            wishFilter = 0
            requirement = null
            needReservationFilter = 0

            // Clear tags
            selectedTags = ""
            js("setTagsFromJS")("")

            // Update map markers
            val filter = PlaceFilter()
            filter.deviceId = deviceId
            filter.listId = "Main List"
            js("setPlacesFilter")(Json.encodeToString(filter))
            js("loadMarkers")(deviceId)
        }

        ButtonGroupFilter(coroutineScope, "top", true/*resetButtonEnabled*/,
            onResetFilter = { resetAllFilters() }
            , onClickFilter = {onClickFilter()})

        // Restaurant Details Section
        Box(FormGroup.toModifier()) {
//                Label(FormLabel.toModifier().toAttrs()) { Text("Restaurant Details") }
            StyledTextInput(
                "place_name_filter", "Place Name starts with",
                Modifier.position(Position.Relative).fontSize(10.px).width(200.px)
            )
        }

        // Rating Filter Section
        Box(FormGroup.toModifier()) {
            Column(
                modifier = Modifier.margin(top = 4.px)
            ) {
                Span(TextSpanModifier.toModifier().toAttrs()) {
                    Text("Minimum Rating")
                }
                Box(Modifier.margin(top = 2.px)) {
                    Input(
                        type = InputType.Range,
                        attrs = Modifier
                            .width(200.px)
                            .toAttrs {
                                attr("id", "rating-filter")
                                attr("min", "0")
                                attr("max", "50")
                                attr("step", "5")
                                attr("value", ratingFilter.toString())
                                onInput { event ->
                                    ratingFilter = event.value?.toFloat() ?: 0f
                                    val setRating = js("setRangeFilter") as? (String, Float) -> Unit
                                    val floatValue : Float = 0f
                                    minRatingFilter = (floatValue + ratingFilter) / 10
                                    setRating?.invoke("minRating", minRatingFilter)
                                }
                            }
                    )
                    Span(Modifier.id("minRating").margin(left = 8.px, top = 16.px).toAttrs()) {
                        Text(minRatingFilter.toString())
                    }
                }
            }
        }

        // Rating Filter Section
        Box(FormGroup.toModifier()) {
            Column(
                modifier = Modifier.margin(top = 4.px)
            ) {
                Span(TextSpanModifier.toModifier().toAttrs()) {
                    Text("Max Price")
                }
                Box(Modifier.margin(top = 2.px)) {
                    Input(
                        type = InputType.Range,
                        attrs = Modifier
                            .width(200.px)
                            .toAttrs {
                                attr("id", "price-filter")
                                attr("min", "0")
                                attr("max", "50")
                                attr("step", "5")
                                attr("value", priceFilter.toString())
                                onInput { event ->
                                    priceFilter = event.value?.toFloat() ?: 50f
                                    val setRating = js("setRangeFilter") as? (String, Float) -> Unit
                                    val floatValue : Float = 0f
                                    maxPriceFilter = (floatValue + priceFilter) / 10
                                    setRating?.invoke("maxPrice", maxPriceFilter)
                                }
                            }
                    )
                    Span(Modifier.id("maxPrice").margin(left = 8.px, top = 16.px).toAttrs()) {
                        Text(maxPriceFilter.toString())
                    }
                }
            }
        }

        // Wish Section
        Box(FormGroup.toModifier()) {
//                Label(FormLabel.toModifier().toAttrs()) { Text("Reservation Required?") }
            Column(
                modifier = Modifier.margin(top = 4.px)
            ) {
                Span(TextSpanModifier.toModifier().toAttrs()) {
                    Text("Wish?")
                }

                Box(Modifier.margin(top = 2.px)) {
                    WishSelector(
                        selected = wish,
                        onSelection = {
                            wish = it
                            wishFilter = wish?.ordinal
                        }
                    )
                }
            }

        }

        // Reservation Section
        Box(FormGroup.toModifier()) {
//                Label(FormLabel.toModifier().toAttrs()) { Text("Reservation Required?") }
            Column(
                modifier = Modifier.margin(top = 2.px)
            ) {
                Span(TextSpanModifier.toModifier().toAttrs()) {
                    Text("Reservation Required?")
                }
                Box(Modifier.margin(top = 2.px)) {
                    RequirementSelector(
                        selected = requirement,
                        onSelection = {
                            requirement = it
                            needReservationFilter = requirement?.ordinal
                        }
                    )
                }
            }

        }

        // Tags Section
        Box(FormGroup.toModifier().margin(top = 16.px, bottom = 0.px)) {
            // This is a workaround to avoid using Label component
//                Label(FormLabel.toModifier().toAttrs()) { Text("Categories") }
            Column(
                modifier = Modifier.margin(top = 0.px)
            ) {
                Span(TextSpanModifier.toModifier().toAttrs()) {
                    Text("Categories")
                }
                Box(Modifier.margin(top = 8.px, bottom = 0.px)) {
                    RestaurantTagsSelector("tags_filter", 1)
                }
            }
        }
        //Span(attrs = Modifier.height(1000.px).toAttrs()) {Text("gvfdeg")  }

        ButtonGroupFilter(coroutineScope, "bottom", true,
            onResetFilter = { resetAllFilters() }
            , onClickFilter = {onClickFilter()})
    }
//    }
}

@Composable
fun SideContent(onCloseWindow: () -> Unit = {}) {

    var isLoggedIn by remember { mutableStateOf(false) }

    isLoggedIn = !window.localStorage.getItem("username").isNullOrBlank()

    if (!isLoggedIn) {
        return
    }
    val coroutineScope = rememberCoroutineScope()

    var username by remember { mutableStateOf("") }
    var requirement by remember { mutableStateOf<Requirement?>(null) }
    var ready by remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
        window.asDynamic().setRequirementSelection = { ordinal: Int ->
            // Update the Compose state from JS
            requirement = Requirement.values().getOrNull(ordinal)
        }
    }

    LaunchedEffect(Unit) {
        window.asDynamic().resetSideContent = {
            // Reset all form fields
//            val placeNameInput = document.getElementById("place_name") as? HTMLInputElement
//            placeNameInput?.value = ""

            val placeNotesInput = document.getElementById("place_notes") as? HTMLTextAreaElement
            placeNotesInput?.value = ""

            val placeWishInput = document.getElementById("place_wish") as? HTMLInputElement
            placeWishInput?.checked = false

//            val placeIdInput = document.getElementById("place_id") as? HTMLInputElement
//            placeIdInput?.value = ""

            val placeLatlngInput = document.getElementById("place_latlng") as? HTMLInputElement
            placeLatlngInput?.value = ""

            val recordIdInput = document.getElementById("record_id") as? HTMLInputElement
            recordIdInput?.value = ""

            // Reset rating and price rating
            js("setRatingFromJS")(0.0)
            js("setPriceRatingFromJS")(0.0)

            // Reset requirement selection
            requirement = null
            needReservation = 0

            // Reset tags
            selectedTags = ""
            js("setTagsFromJS")("")

            // Reset delete button state
            js("enableDeleteButton")(false)
        }
    }

    val isMobile = window.innerWidth <= 480

    Column(
        modifier = FormContainer.toModifier().width(80.vw),
        horizontalAlignment = Alignment.Start
    ) {

        var rating by remember { mutableStateOf(0.0) }
        var priceRating by remember { mutableStateOf(0.0) }

        LaunchedEffect(Unit) {
            window.asDynamic().setRatingFromJS = { value: Double ->
                rating = value
                console.log("setRatingFromJS:" + value)
            }
            window.asDynamic().setPriceRatingFromJS = { value: Double ->
                priceRating = value
                console.log("setPriceRatingFromJS:" + value)
            }
        }

        var deleteButtonEnabled by remember { mutableStateOf(false) }
        var mapsLink by remember { mutableStateOf("") }

//        if(isMobile) {
            com.varabyte.kobweb.silk.components.forms.Button(
                onClick = { onCloseWindow() },
                modifier = Modifier.margin(bottom = 8.px)
            ) {
                Text("Close")
            }
//        }
        LaunchedEffect(Unit) {
            window.asDynamic().enableDeleteButton = { flag: Boolean ->
                console.log("enableDeleteButton:" + flag)
                deleteButtonEnabled = flag
            }
            window.asDynamic().window.setMapsLink = { link: String ->
                mapsLink = link
                console.log("setMapsLink:" + link)
            }
        }


        ButtonGroup(coroutineScope, "top", deleteButtonEnabled, rating, priceRating)

        // Restaurant Details Section
        Box(FormGroup.toModifier()) {
//                Label(FormLabel.toModifier().toAttrs()) { Text("Restaurant Details") }
            StyledTextInput("place_name", "Place Name")

        }


        // Rating Section
        Box(FormGroup.toModifier()) {
//                Label(FormLabel.toModifier().toAttrs()) { Text("Your Rating") }
            Column(
                modifier = Modifier.margin(top = 16.px)
            ) {
                Box(Modifier.margin(top = 32.px)) {
                }

                if(!mapsLink.isEmpty()) {
                    Link(
                        mapsLink,
                        SocialLinkStyle.toModifier()
                    ) {
                        Image(
                            src = "/social/google-maps.svg",
                            alt = "Google Maps",
                            modifier = Modifier.width(32.px).height(32.px)
                        )
                    }
                }
                Span(TextSpanModifier.toModifier().toAttrs()) {
                    Text("Rating")
                }
                Box(Modifier.margin(top = 8.px)) {
                    Rating(
                        rating = rating,
                        empty = "/rating/star-empty.svg",
                        full = "/rating/star-full.svg",
                        half = "/rating/star-half.svg",
                        onRatingChanged = { newRating ->
                            rating = newRating
                            console.log("Rating changed: $newRating")
                        }
                    )
                }
            }
        }

        // Price Range Section
        Box(FormGroup.toModifier()) {
//                Label(FormLabel.toModifier().toAttrs()) { Text("Price Range") }

            Column(
                modifier = Modifier.margin(top = 16.px)
            ) {
                Span(TextSpanModifier.toModifier().toAttrs()) {
                    Text("Price Range")
                }
                Box(Modifier.margin(top = 8.px)) {
                    Rating(
                        rating = priceRating,
                        empty = "/rating/dollar-empty.svg",
                        full = "/rating/dollar-full.svg",
                        half = "/rating/dollar-half.svg",
                        onRatingChanged = { newRating ->
                            priceRating = newRating
                            console.log("Price rating changed: $newRating")
                        }
                    )
                }
            }
        }

        // Reservation Section
        Box(FormGroup.toModifier()) {
//                Label(FormLabel.toModifier().toAttrs()) { Text("Reservation Required?") }
            Column(
                modifier = Modifier.margin(top = 4.px)
            ) {
                Span(TextSpanModifier.toModifier().toAttrs()) {
                    Text("Reservation Required?")
                }
                Box(Modifier.margin(top = 2.px)) {
                    RequirementSelector(
                        selected = requirement,
                        onSelection = {
                            requirement = it
                            needReservation = requirement?.ordinal
                        }
                    )
                }
            }

        }

        // Hidden Fields
        StyledHidden("place_mode")
        StyledHidden("place_id")
        StyledHidden("place_latlng")
        StyledHidden("record_id")

        // Tags Section
        Box(FormGroup.toModifier().margin(top = 16.px, bottom = 0.px)) {
            // This is a workaround to avoid using Label component
//                Label(FormLabel.toModifier().toAttrs()) { Text("Categories") }
            Column(
                modifier = Modifier.margin(top = 0.px)
            ) {
                Span(TextSpanModifier.toModifier().toAttrs()) {
                    Text("Categories")
                }
                Box(Modifier.margin(top = 8.px, bottom = 0.px)) {
                    RestaurantTagsSelector()
                }
            }
        }

        // Wish List & Notes Section
        Box(FormGroup.toModifier()) {

            Column(
                modifier = Modifier.margin(top = 0.px)
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.Start,
                    verticalAlignment = Alignment.Top
                ) {
                    StyledCheckbox("place_wish", "Add to Wish List")
                }
                Span(TextSpanModifier.toModifier().toAttrs()) {
                    Text("Notes")
                }
                Box(Modifier.margin(top = 0.px)) {
                    StyledTextAreaInput("place_notes", "Add your notes here...")
                }
            }
        }

        ButtonGroup(coroutineScope, "bottom", deleteButtonEnabled, rating, priceRating)
    }
//    }
}

@Composable
private fun ButtonGroupFilter(
    coroutineScope: CoroutineScope,
    position: String,
    enabled: Boolean,
    onResetFilter: () -> Unit = { },
    onClickFilter: () -> Unit = { }
) {
    var showSaveMessage by remember { mutableStateOf(false) }

    Column {
        Row(modifier = Modifier.padding(16.px)) {
            // Save Button
            com.varabyte.kobweb.silk.components.forms.Button(
                onClick = {
                    coroutineScope.launch {
                        val placeNameFilter = (window.document.getElementById("place_name_filter") as HTMLInputElement).value
                        val wish = (window.document.getElementById("place_wish") as HTMLInputElement).checked

                        try {

                            val filter = PlaceFilter()
                            filter.name = placeNameFilter
                            filter.tags = selectedTags
//                            filter.tags = selectedTags.split(";").filter { it.isNotBlank() }
                            filter.wish = wishFilter ?: 0
                            filter.needReservation = needReservationFilter ?: 0
                            filter.deviceId = deviceId
                            filter.listId = "Main List"
                            filter.placeType = "restaurant"
                            filter.ratingMin = minRatingFilter ?: 0f
                            filter.priceRangeMax = maxPriceFilter ?: 5f
//                            filter.priceRangeMax = 4f

                            console.log("filter:" + filter)

                            Json.encodeToString(filter).let { jsonFilter ->
                                console.log("jsonFilter:" + jsonFilter)

                                js("setPlacesFilter")(jsonFilter)
                                val loadMarkers = js("loadMarkers") as? (String) -> Unit
                                loadMarkers?.invoke(deviceId)
                            }
                            console.log("before onClickFilter")
                            onClickFilter()
                            console.log("after onClickFilter")
                        } catch (e: Exception) {
                            console.log("Error during fetch: ${e.message}")
                        }
                    }
                },
                modifier = ButtonModifier.toModifier()
            ) {
                Span(TextSpanModifier.toModifier().toAttrs()) {
                    Text("Filter")
                }
            }

            com.varabyte.kobweb.silk.components.forms.Button(
                onClick = {
                    onResetFilter()
                },
                modifier = ButtonModifier.toModifier(),
                enabled = enabled
            ) {
                Span(TextSpanModifier.toModifier().toAttrs()) {
                    Text("Reset Filter")
                }
            }
        }

        // Success message
        if (showSaveMessage) {
            Text(
                "Filtered!",
            )
        }
    }
}

@Composable
private fun ButtonGroup(
    coroutineScope: CoroutineScope,
    position: String,
    enabled: Boolean,
    rating: Double,
    priceRating: Double
) {
//    var showSaveMessage by remember { mutableStateOf(false) }

    Column {
        Row(modifier = Modifier.padding(16.px)) {
            // Save Button
            com.varabyte.kobweb.silk.components.forms.Button(
                onClick = {
                    console.log("onClickSave")
                    coroutineScope.launch {
                        val placeName = (window.document.getElementById("place_name") as HTMLInputElement).value
                        val placeId = (window.document.getElementById("place_id") as HTMLInputElement).value
                        val latlng = (window.document.getElementById("place_latlng") as HTMLInputElement).value.toString()
                        val notes = (window.document.getElementById("place_notes") as HTMLTextAreaElement).value
                        val recordId = (window.document.getElementById("record_id") as HTMLInputElement).value
                        val wish = (window.document.getElementById("place_wish") as HTMLInputElement).checked

                        try {
                            // Create request body
                            val requestBody = json(
                                "deviceId" to deviceId,
                                "name" to placeName,
                                "placeId" to placeId,
                                "rating" to rating,
                                "priceRange" to priceRating,
                                "latlng" to latlng,
                                "notes" to notes,
                                "tags" to formatTagsAsJson(selectedTags),
                                "isWish" to wish,
                                "needReservation" to needReservation,
                                "recordId" to recordId,
                                "listId" to "Main List"
                            )

                            // Make POST request
                            val response = window.fetch(
                                apiEndpoint + "/api/save-place",
                                RequestInit(
                                    method = "POST",
                                    headers = json("Content-Type" to "application/json"),
                                    body = JSON.stringify(requestBody)
                                )
                            ).await()

                            val jsonText = response.text().await()
                            console.log("Raw response: $jsonText")

                            if (response.ok) {
                                val jsonElement = Json.parseToJsonElement(jsonText)
                                val recordIdRes = jsonElement.jsonObject["result"]?.toString() ?: ""
                                console.log("Parsed recordId: $recordIdRes")
                                (window.document.getElementById("record_id") as HTMLInputElement).value = recordIdRes.replace("\"", "")

                                val loadMarkers = js("loadMarkers") as? (String) -> Unit
                                loadMarkers?.invoke(deviceId)

                                (js("showSideContent") as? (Boolean) -> Unit)?.invoke(false)
                                // Show success message
//                                showSaveMessage = true
//                                delay(1000) // Wait 1 second
//                                showSaveMessage = false
                            } else {
                                console.log("Error saving place: ${response.statusText}")
                            }
                        } catch (e: Exception) {
                            console.log("Error during fetch: ${e.message}")
                        }
                    }
                },
                modifier = ButtonModifier.toModifier()
            ) {
                Text("Save")
            }

            com.varabyte.kobweb.silk.components.forms.Button(
                onClick = {
                    coroutineScope.launch {
                        val recordId =
                            (window.document.getElementById("record_id") as HTMLInputElement).value
                        try {
                            // Create request body
                            val requestBody = json(
                                "deviceId" to deviceId,
                                "recordId" to recordId,
                            )

                            // Make POST request
                            val response = window.fetch(
                                apiEndpoint + "/api/delete-place",
                                RequestInit(
                                    method = "POST",
                                    headers = json("Content-Type" to "application/json"),
                                    body = JSON.stringify(requestBody)
                                )
                            ).await()

                            val jsonText = response.text().await()
                            console.log("Raw response: $jsonText")

                            if (response.ok) {
                                val jsonElement = Json.parseToJsonElement(jsonText)
                                val recordIdRes =
                                    jsonElement.jsonObject["result"]?.toString() ?: ""
                                console.log("Deleted recordId: $recordIdRes")

                                val loadMarkers = js("loadMarkers") as? (String) -> Unit
                                loadMarkers?.invoke(deviceId)
                                (js("showSideContent") as? (Boolean) -> Unit)?.invoke(false)
                            } else {
                                console.log("Error deleting place: ${response.statusText}")
                            }
                        } catch (e: Exception) {
                            console.log("Error during fetch: ${e.message}")
                        }
                    }
                },
                modifier = ButtonModifier.toModifier(),
                enabled = enabled
            ) {
                Text("Delete")
            }
        }

        // Success message
//        if (showSaveMessage) {
//            Text(
//                "Saved!",
////                modifier = Modifier
////                    .color(rgb(34, 197, 94)) // Green color
////                    .fontSize(10.px)
////                    .margin(top = 4.px)
////                    .textAlign(TextAlign.Center)
//            )
//        }
    }
}

fun formatTagsAsJson(selectedTags: String) :String {
    var s = "[ "
    selectedTags.split(";").forEach {
        if (it.isNotEmpty()) {
            s += "\"$it\","
        }
    }
    return s.substring(0, s.length - 1) + "]"
}

@Composable
fun Rating(
    modifier: Modifier = Modifier,
    maxRating: Int = 5,
    rating: Double = 0.0,
    empty: String = "/rating/star-empty.svg",
    full: String = "/rating/star-full.svg",
    half: String = "/rating/star-half.svg",
    onRatingChanged: (Double) -> Unit = {}
) {
    val fullStars = floor(rating).toInt()
    val hasHalfStar = (rating - fullStars) >= 0.5

    Div(
        Modifier
            .display(DisplayStyle.Flex)
            .alignItems(AlignItems.Center)
            .margin(bottom = 8.px)
            .toAttrs()
    ) {
        for (i in 1..maxRating) {
            val isFull = i <= fullStars
            val isHalf = i == fullStars + 1 && hasHalfStar

            Box(
                modifier = Modifier
                    .cursor(Cursor.Pointer)
                    .padding(right = 4.px)
                    .onClick { e ->
                        val rect = (e.currentTarget as Element).getBoundingClientRect()
                        val x = e.clientX - rect.left
                        val width = rect.width
                        val position = x / width

                        val newRating = if (position < 0.5) {
                            i - 0.5
                        } else {
                            i.toDouble()
                        }
                        onRatingChanged(newRating.coerceIn(0.0, maxRating.toDouble()))
                    }
            ) {
                Image(
                    src = when {
                        isFull -> full
                        isHalf -> half
                        else -> empty
                    },
                    alt = when {
                        isFull -> "Full"
                        isHalf -> "Half"
                        else -> "Empty"
                    },
                    modifier = Modifier.size(32.px)
                )
            }
        }
    }
}
//
//@Composable
//fun StyledTextInput(
//    id: String, placeHolder: String, modifier: Modifier = Modifier.position(Position.Relative)
//        .fontSize(10.px).width(250.px), zIndex: Int = 1, topMargin: CSSSizeValue<CSSUnit.px> = 0.px,
//    iconSize : CSSSizeValue<CSSUnit.px> = 16.px
//) {
//    var text by remember { mutableStateOf("") }
//
//    Box(
//        modifier = modifier
//    ) {
//        Row(
////            modifier = Modifier.width(80.percent),
//            verticalAlignment = Alignment.CenterVertically
//        ) {
//            Input(
//                type = InputType.Text,
//                attrs = modifier
////                    .width(250.px)
//                    .padding(8.px)
////                    .fontSize(10.px)
//                    .borderRadius(8.px)
//                    .border(1.px, LineStyle.Solid, Color.gray)
//                    .padding(6.px)
//                    .toAttrs {
//                        attr("placeholder", placeHolder)
//                        attr("id", id)
//                        attr("value", text)
//                        onInput { event: SyntheticInputEvent<String, HTMLInputElement> ->
//                            text = event.value
//                        }
//                    }
//            )
//
//            if (text.isNotEmpty()) {
//                com.varabyte.kobweb.silk.components.forms.Button(
//                    onClick = {
//                        text = ""
//                        val input = document.getElementById(id) as HTMLInputElement
//                        input.value = ""
//                        // Trigger the place_changed event to clear the map marker
//                        js("document.getElementById(id).dispatchEvent(new Event('input'))")
//                    },
//                    modifier = Modifier
//                        .position(Position.Absolute)
//                        .right(8.px)
//                        .padding(4.px)
//                        .zIndex(zIndex)
//                        .margin(top = topMargin)
//                        .backgroundColor(Colors.Transparent)
////                        .backgroundColor(Colors.Black)
//                        .cursor(Cursor.Pointer)
//                ) {
//                    Image(
//                        src = "/icons/clear.svg",
//                        alt = "Clear",
//                        modifier = Modifier.size(iconSize)
////                        modifier = Modifier.size(64.px)
//                    )
//                }
//            }
//        }
//    }
//}
//
//@Composable
//fun StyledTextAreaInput(id: String, placeHolder: String) {
//    var text by remember { mutableStateOf("") }
//
//    TextArea (
//        attrs = Modifier
//            .width(100.percent)
//            .padding(4.px)
//            .fontSize(10.px)
//            .borderRadius(8.px)
//            .border(1.px, LineStyle.Solid, Color.gray)
//            .padding(4.px)
//            .toAttrs {
//                attr("placeholder", placeHolder)
//                attr("id", id)
//                attr("value", text)
//                attr("rows", "4")
//                attr("cols", "50")
//                onInput { event ->
//                    text = event.value
//                }
//            }
//    )
//}
//
//@Composable
//fun StyledCheckbox(id: String, placeHolder: String, isChecked: Boolean = false) {
//    var isChecked by remember { mutableStateOf(false) }
//
//    Span(
//        TitleStyle.toModifier().whiteSpace(WhiteSpace.PreWrap).textAlign(TextAlign.Center)
//            .toAttrs()
//    ) {
//        Label(
//            attrs = Modifier
//                //.width(CSSAutoKeyword)
//                .padding(4.px)
//                .fontSize(10.px)
//                .toAttrs {
//                    attr("placeholder", placeHolder)
//                    attr("id", id + "_label")
//                    attr("value", placeHolder)
////                onInput { event: SyntheticInputEvent<String, HTMLInputElement> ->
////                    text = event.value
////                }
//                }) {
//            Text(placeHolder)
//        }
//        Input(
//            type = InputType.Checkbox,
//            attrs = Modifier
////                .borderRadius(8.px)
////                .border(1.px, LineStyle.Solid, Color.gray)
//                .toAttrs {
//                    attr("id", id)
//                    attr("checked", isChecked.toString()) // <-- ✅ value goes here!
////                onInput { event: SyntheticInputEvent<String, HTMLInputElement> ->
////                    text = event.value
////                }
//                }
//        )
//    }
//}
//
//@Composable
//fun StyledHidden(id: String, mode: String = "register") {
//    var value by remember { mutableStateOf("") }
//
//    Span(
//        HiddenStyle.toModifier().whiteSpace(WhiteSpace.PreWrap).textAlign(TextAlign.Center)
//            .backgroundColor(Colors.Transparent)
//            .toAttrs()
//    ) {
//        Input(
//            type = InputType.Hidden,
//            attrs = Modifier
//                .toAttrs {
//                    attr("id", id)
//                }
//        )
//    }
//}
//
//
//@Composable
//fun ForgotPassword() {
//    //var email by remember { mutableStateOf("") }
//    var message by remember { mutableStateOf("") }
//    var messageColor by remember { mutableStateOf(Colors.Black) }
//
//    Column(
//        modifier = Modifier.fillMaxWidth().margin(top = 50.px),
//        horizontalAlignment = Alignment.Start,
//        verticalArrangement = Arrangement.Center
//    ) {
//        Span(Modifier.fontWeight(FontWeight.Bold).toAttrs()) {
//            Text("Forgot Password")
//        }
//        Row(modifier = Modifier.gap(16.px)) {
//            Text("Email:")
//            StyledTextInput(
//                id = "forgot_password_email",
//                placeHolder = "Enter your email"
//                //modifier = Modifier.width(300.px).margin(bottom = 10.px)
//            )
//        }
////        TextInput(
////            value = email,
////            onValueChange = { email = it },
////            modifier = Modifier
////                .width(300.px)
////                .margin(bottom = 10.px),
////            placeholder = "Enter your email"
////        )
//
//        //val coroutineScope = rememberCoroutineScope()
//        com.varabyte.kobweb.silk.components.forms.Button(
//            onClick = {
//                val email =
//                    (window.document.getElementById("forgot_password_email") as HTMLInputElement).value
//                console.log("Forgot password email: $email")
//                if (email.isNotEmpty()) {
//                    window.fetch(
//                        apiEndpoint + "/api/reset-password",
//                        RequestInit(
//                            method = "POST",
//                            headers = json("Content-Type" to "application/json"),
//                            body = Json.encodeToString(mapOf("email" to email, "deviceId" to "", "password" to ""))
//                        )
//                    ).then { response ->
//                        response.text().then { body ->
//                            if (response.ok) {
//                                messageColor = Colors.Green
//                                message = "Password reset instructions sent to your email"
//                            } else {
//                                messageColor = Colors.Red
//                                message = body
//                            }
//                        }
//                    }
//                } else {
//                    messageColor = Colors.Red
//                    message = "Please enter your email"
//                }
//            }
//        )
//        {
//            Text("Reset Password")
//        }
//
//        if (message.isNotEmpty()) {
//            Text(
//                message
//                //,modifier = Modifier.color(messageColor)
//            )
//        }
//    }
//}
//
//
//@Composable
//fun LoginForm(onLoginSuccess: (String, String) -> Unit) {
//    var username by remember { mutableStateOf("") }
//    var password by remember { mutableStateOf("") }
//    var message by remember { mutableStateOf("") }
//    var showPassword by remember { mutableStateOf(false) }
//    var showResetForm by remember { mutableStateOf(false) }
//
//    Column {
//        Span(Modifier.fontWeight(FontWeight.Bold).toAttrs()) {
//            Text("Login")
//        }
//        Row(modifier = Modifier.gap(16.px)) {
//            Text("Email:")
//            Input(
//                type = InputType.Text,
//                attrs = Modifier
//                    .toAttrs {
//                        attr("placeholder", "Username")
//                        attr("id", "username")
//                        onInput { event: SyntheticInputEvent<String, HTMLInputElement> ->
//                            username = event.value
//                        }
//                    }
//            )
//        }
//        Row(modifier = Modifier.gap(16.px)) {
//            Text("Password:")
//            Input(
//                type = if (showPassword) InputType.Text else InputType.Password, // Toggle visibility
//                attrs = Modifier
//                    .toAttrs {
//                        attr("placeholder", "Password")
//                        attr("id", "password")
//                        onInput { event: SyntheticInputEvent<String, HTMLInputElement> ->
//                            password = event.value
//                        }
//                    }
//            )
//        }
//        Row(modifier = Modifier.gap(16.px)) {
//            Input(
//                type = InputType.Checkbox,
//                attrs = Modifier.toAttrs {
//                    onInput { event -> showPassword = event.value == true }
//                }
//            )
//            Text("Show Password")
//        }
//        com.varabyte.kobweb.silk.components.forms.Button(
//            onClick = {
//                message = ""
//                val isValidEmail = validEmail(email = username)
//                if (!isValidEmail) {
//                    message = "Please enter a valid email address"
//                    return@Button
//                }
//                window.fetch(
//                    apiEndpoint + "/api/login",
//                    RequestInit(
//                        method = "POST",
//                        headers = json(
//                            "Content-Type" to "application/json",
//                            "Accept" to "application/json",
//                        ),
//                        body = Json.encodeToString(UserCredentials(username, password, ""))
//                    )
//                )
//                    .then { response ->
//                        if (response.ok) {
//                            response.text().then { body ->
//                                val json = JSON.parse<dynamic>(body)
//                                val name = json.username as String
//                                val deviceId = json.deviceId as String
//                                onLoginSuccess(name, deviceId)
//                            }
//                        } else {
//                            message = "Invalid username or password"
//                        }
//                    }
//                    .catch {
//                        console.log("Error during fetch: ${it.message}")
//                        message = "An error occurred during login: ${it.message}"
//                    }
//            }) { Text("Login") }
//
////        Link("/register") { org.w3c.dom.Text("Register") }
////        Link("/recover") { org.w3c.dom.Text("Forgot Password?") }
//        Text(value=message)
//
//        Link(
//            path = "",
//            modifier = Modifier.onClick { showResetForm = !showResetForm }
//            //,onClick = {}
//        ) {
//            Text("Reset Password")
//        }
//        if (showResetForm) {
//            ForgotPassword()
//        }
//    }
//}
//
//
////@Serializable
////data class UserCredentials(val email: String, val password: String, val deviceId: String)
//
//
//
//private suspend fun fetch(method: String, url: String, body: dynamic = null): Response =
//    window.fetch(
//        url, RequestInit(
//            method = method,
//            body = body,
//            headers = json(
//                "Content-Type" to "application/json",
//                "Accept" to "application/json",
//                "pragma" to "no-cache"
//            )
//        )
//    ).await()
//
//private suspend fun post(url: String, body: dynamic): Response =
//    fetch("POST", url, JSON.stringify(body))
//
//@Composable
//fun RegisterForm(onRegisterSuccess: (String) -> Unit) {
//    var username by remember { mutableStateOf("") }
//    var password by remember { mutableStateOf("") }
//    var confirmPassword by remember { mutableStateOf("") }
//    var message by remember { mutableStateOf("") }
//    var showPassword by remember { mutableStateOf(false) } // NEW
//
//    Column {
//        Span(Modifier.fontWeight(FontWeight.Bold).toAttrs()) {
//            Text("Register")
//        }
//        Row(modifier = Modifier.gap(16.px)) {
//            Text("Email:")
//            Input(
//                type = InputType.Text,
//                attrs = Modifier
//                    .toAttrs {
//                        attr("placeholder", "Email")
//                        attr("id", "username")
//                        onInput { event -> username = event.value }
//                    }
//            )
//        }
//        Row(modifier = Modifier.gap(16.px)) {
//            Text("Password:")
//            Input(
//                type = if (showPassword) InputType.Text else InputType.Password, // Toggle visibility
//                attrs = Modifier
//                    .toAttrs {
//                        attr("placeholder", "Password")
//                        attr("id", "password")
//                        onInput { event -> password = event.value }
//                    }
//            )
//        }
//        Row(modifier = Modifier.gap(16.px)) {
//            Text("Confirm Password:")
//            Input(
//                type = if (showPassword) InputType.Text else InputType.Password, // Toggle visibility
//                attrs = Modifier
//                    .toAttrs {
//                        attr("placeholder", "Confirm Password")
//                        attr("id", "confirmPassword")
//                        onInput { event -> confirmPassword = event.value }
//                    }
//            )
//        }
//        Row(modifier = Modifier.gap(16.px)) {
//            Input(
//                type = InputType.Checkbox,
//                attrs = Modifier.toAttrs {
//                    onInput { event -> showPassword = event.value == true }
//                }
//            )
//            Text("Show Password")
//        }
//        com.varabyte.kobweb.silk.components.forms.Button(
//            onClick = {
//                message = ""
//                if (password != confirmPassword) {
//                    message = "Passwords do not match"
//                    return@Button
//                }
//                val isValidEmail = validEmail(email = username)
//                if (!isValidEmail) {
//                    message = "Please enter a valid email address"
//                    return@Button
//                }
//                window.fetch(
//                    apiEndpoint + "/api/register",
//                    RequestInit(
//                        method = "POST",
//                        headers = json("Content-Type" to "application/json", "Accept" to "application/json"),
//                        body = Json.encodeToString(UserCredentials(username, password, ""))
//                    )
//                ).then { response ->
//                    response.text().then { body ->
//                        if (response.ok) {
//                            onRegisterSuccess(username)
//                            message = "Please check your email for confirmation."
//                        } else {
//                            message = body
//                            console.log("Error response body: $body")
//                        }
//                    }
//                }
//            }) { Text("Register") }
//        Text(value = message)
//    }
//}
//
//
//
//@Composable
//fun ResetPassForm(email:String?, resetCode:String?, onSetNewPasswordSuccess: (String, String) -> Unit) {
////    var username by remember { mutableStateOf("") }
//    var password by remember { mutableStateOf("") }
//    var message by remember { mutableStateOf("") }
//
//    Column {
//        Text("Reset Password")
//        Input(
//            type = InputType.Text,
//            attrs = Modifier
//                .toAttrs {
//                    attr("placeholder", "Username")
//                    attr("id", "username")
//                    attr("value", email?: "")
//                    //onInput { event -> username = event.value }
//                }
//        )
//        Input(
//            type = InputType.Password,
//            attrs = Modifier
//                .toAttrs {
//                    attr("placeholder", "Password")
//                    attr("id", "password")
//                    onInput { event -> password = event.value }
//                }
//        )
//        com.varabyte.kobweb.silk.components.forms.Button(
//            onClick = {
//                message = ""
//                window.fetch(
//                    apiEndpoint + "/api/set-password",
//                    RequestInit(
//                        method = "POST",
//                        headers = json("Content-Type" to "application/json","Accept" to "application/json"),
//                        body = Json.encodeToString(UserCredentials(email ?: "", password, "",
//                            true, "", resetCode ?: ""))
//                    )
//                ).then { response ->
//                    response.text().then { body ->
//                        if (response.ok) {
//                            onSetNewPasswordSuccess(email ?: "", resetCode ?: "")
//
//                        } else {
//                            message = body
//                            console.log("Error response body: $body")
//                        }
//                    }
//                }
//            }) { Text("Set Password") }
//        Text(value=message)
//    }
//}
//
//
//@Serializable
//data class RecoveryRequest(val email: String)
